export default {
  name: 'Export',
  computed: {
    componentTitle () {
      return this.$t(`ComponentTitle.${this.$route.name}`)
    },
    isExportDisabled () {
      if (!this.dateRange) return true
      return !!this.error
    }
  },
  data () {
    return {
      component: 'export',
      dateRange: null,
      error: '',
      pickerOptions: {
        disabledDate: date => {
          const now = Date.now()
          if (now < date) return true

          const relativeStart = this.theme.export.relative_start
          if (isNaN(relativeStart)) return
          if (now > +date + relativeStart * 1000) return true
        }
      },
      theme: {}
    }
  },
  methods: {
    onPickerChange ([ minDate, maxDate ]) {
      const period = +maxDate + 86400000 - +minDate
      const max = this.theme.export.period_max
      const min = this.theme.export.period_min
      if (
        period > max * 1000 ||
        period < min * 1000
      ) {
        this.error = this.$t('exportPeriodError', {
          min: min / 60 / 60,
          max: max / 60 / 60
        })
      } else {
        this.error = ''
      }
    },
    exportData ([minDate, maxDate]) {
      this.$api.exportData({
        startTime: +minDate / 1000,
        endTime: +maxDate / 1000
      })
        .then(({ body }) => this.$alert(body, 'Job ID'))
        .catch(({ body }) => this.$alert(body, 'Error'))
    }
  },
  mounted () {
    return this.$api.getTheme()
      .then(({ body }) => {
        this.theme = body
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/Export/Export.js